<template>
  <button class="c-burger" :class="{ 'c-burger--open': isNavOpen }" @click="toggleNav" aria-label="burger">
    <ul class="c-burger__list">
      <li />
      <li />
      <li />
    </ul>
  </button>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isNavOpen: state => state.navigation.isNavOpen
    })
  },
  methods: {
    toggleNav() {
      this.$store.commit("navigation/TOGGLE_NAV", !this.isNavOpen);
    }
  }
};
</script>

<style lang="scss">
.c-burger {
  display: flex;
  position: relative;
  /* add a tiny padding arround which helps on touch */
  padding: 3px;
  width: calc(33px + 6px); // overwrite this value to be sure that the nav don't skrink
  height: calc(1.4rem + 6px);
  margin-left: -3px;
  margin-top: -3px;
  cursor: pointer;

  &__list {
    @include reset-list;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    li {
      @include transition(0.3s ease-in-out all);
      height: 2px;
      width: 100%;
      background-color: $color-white;

      .header-bar--scrolled & {
        background-color: $color-lighter;
      }

      &:nth-child(1) {
        .c-burger--open & {
          @include transform(translate(0px, 0.65rem));
        }
      }
      &:nth-child(2) {
        width: 70%;
        .c-burger--open & {
          width: 100%;
        }
      }
      &:nth-child(3) {
        .c-burger--open & {
          @include transform(translate(0px, -0.65rem));
        }
      }
    }
  }
}
</style>
